import Wordmark from './Wordmark';
import { BRAND, footerLinks } from '../data';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-top">
        <Wordmark inverted className="footer-wordmark" />
        <nav aria-label="Footer navigation">
          {footerLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="container footer-bottom">
        <p>© {new Date().getFullYear()} {BRAND}. All rights reserved.</p>
        <p className="footer-legal">
          <a href="#top">Privacy Policy</a>
          <a href="#top">Terms</a>
        </p>
      </div>
    </footer>
  );
}
